import EmptyState from '@components/EmptyState'
import React from 'react'

const EmptyLessons: React.FC = () => (
  <EmptyState heading="No lessons scheduled today" img="/images/empty-events-24.svg" />
)

export default EmptyLessons
